<template>
  <div style="padding:0; position:relative; height:100%; width:100%; flex:1;">
    <div class="outer-new-request-panel">
    <div class="new-request-panel" style="position:absolute; top:24px; z-index:10; width:420px;">
      <div class="new-request-panel-content">
        <div class="new-request-head">
          <el-scrollbar max-height="220px">
            <template v-for="(location, index) in formInputs.locations" :key="index">
              <el-row
                class="new-request-location-row-breather__minimal"
                v-if="index == 0"
              ></el-row>
              <el-row>
                <el-col :span="2"
                  ><el-icon
                    size="small"
                    class="new-request-location-icon"
                    style="display: none"
                    :class="{
                      'new-request-pickup-location-icon': isNewLocationPickupIcon(index),
                      'new-request-delivery-location-icon': isNewLocationDeliveryIcon(index),
                    }"
                    ><MapLocation /></el-icon
                ></el-col>
                <el-col :span="20"
                  ><GMapAutocomplete
                    :placeholder="setPlaceHolderName(index)"
                    @place_changed="setPlace($event, index)"
                    class="request-stop"
                    :options="autocompleteOptions"
                  >
                  </GMapAutocomplete
                ></el-col>
                <el-col :span="2" v-show="displayDeleteIcon(index)">
                  <el-tooltip content="Delete this location" placement="top">
                    <el-icon
                      size="small"
                      @click="removeLocation(index)"
                      class="new-request-location-icon new-request-location-icon__actionable"
                      ><Delete /></el-icon
                  ></el-tooltip>
                </el-col>
              </el-row>
              <el-row class="new-request-location-row-breather"></el-row>
            </template>

            <div v-if="allowNewLocation">
              <el-row>
                <el-col :span="2"></el-col>
                <el-col :span="20">
                  <span class="new-request-add-destination-button" @click="addNewDestination">
                    <a class="add-destination"> <strong> + </strong> Add Destination</a>
                  </span>
                </el-col>
                <el-col :span="2"></el-col>
              </el-row>
            </div>
          </el-scrollbar>
        </div>
        <el-divider />

        <Transition name="panel-slide">
        <div class="new-request-body-section">
          <div v-if="showMinimisedBody">
            <div class="get-price-row">
              <button class="get-price-btn" @click="getPriceQuote" :disabled="loading || !isValidForm">
                <span v-if="loading" class="confirm-spinner"></span>
                {{ loading ? 'Getting prices…' : 'Get Price' }}
              </button>
            </div>
          </div>
          <div v-else>
            <el-row>
              <el-col :span="2"></el-col>
              <el-col :span="20">

                <!-- Get Price button (before prices are loaded) -->
                <button
                  v-if="!showPricePanel"
                  class="get-price-btn"
                  @click="getPriceQuote"
                  :disabled="loading"
                  style="width:100%"
                >
                  <span v-if="loading" class="confirm-spinner"></span>
                  {{ loading ? 'Getting prices…' : 'Get Price' }}
                </button>

                <!-- Price tabs (after prices loaded) -->
                <div v-if="showPricePanel && allPrices.length">

                  <!-- Some vehicles price by weight and cannot quote without one.
                       The field also lives under Cargo, but nobody goes looking
                       there for the answer to a greyed-out price. -->
                  <div v-if="awaitingWeight.length" class="weight-prompt">
                    <div class="weight-prompt-text">
                      <strong>{{ awaitingWeight.join(', ') }}</strong>
                      {{ awaitingWeight.length === 1 ? 'is' : 'are' }} priced by weight.
                      Enter your load to see {{ awaitingWeight.length === 1 ? 'its price' : 'their prices' }}.
                    </div>
                    <div class="weight-prompt-field">
                      <input v-model.number="goodsWeight" type="number" min="0" step="0.1"
                             class="weight-prompt-input" placeholder="0.0" aria-label="Goods weight in tonnes" />
                      <span class="weight-prompt-unit">tonnes</span>
                    </div>
                  </div>

                  <el-tabs v-model="vehicleTab" :stretch="true" class="price-tabs">
                    <el-tab-pane v-for="(group, key) in vehicleGroups" :key="key" :name="key"
                      :label="key === 'small' ? 'Small' : key === 'medium' ? 'Medium' : 'Large'">
                      <div
                        v-for="item in group" :key="item.vehicle_type"
                        @click="selectVehicle(item)"
                        :style="{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '7px 12px',
                          borderRadius: '10px',
                          marginBottom: '4px',
                          cursor: item.result ? 'pointer' : 'default',
                          border: formActiveVehicleType === item.vehicle_type
                            ? '2px solid #0061eb'
                            : '1.5px solid #ccdeff',
                          background: formActiveVehicleType === item.vehicle_type
                            ? '#eff6ff'
                            : item.result ? '#fff' : '#f0f6ff',
                          opacity: item.result ? 1 : 0.55,
                          transition: 'all 0.15s',
                        }"
                      >
                        <div style="display:flex; align-items:center; gap:8px;">
                          <span v-if="formActiveVehicleType === item.vehicle_type" style="color:#0061eb; font-size:14px;">✓</span>
                          <span style="font-size:13px; font-weight:600; color:#1e293b;">{{ item.vehicle_type }}</span>
                        </div>
                        <div style="text-align:right;">
                          <span v-if="item.result" style="font-size:15px; font-weight:800; color:#0061eb;">
                            {{ currency }} {{ Number(item.result.customer_amount).toLocaleString() }}
                          </span>
                          <span v-else style="font-size:12px; color:#94a3b8;">{{ item.error }}</span>
                          <div v-if="item.result" style="font-size:10.5px; color:#94a3b8; margin-top:1px;">
                            {{ item.result.pricing_model }} · {{ Math.ceil(distanceKm) }} km
                          </div>
                        </div>
                      </div>
                      <div v-if="!group.length" style="text-align:center; color:#94a3b8; font-size:12px; padding:12px 0;">
                        No vehicles available
                      </div>
                    </el-tab-pane>
                  </el-tabs>

                </div>

              </el-col>
              <el-col :span="2"></el-col>
            </el-row>

            <!-- Lower pill tabs: Cargo / Notes / Manifest / Schedule -->
            <div v-if="showPricePanel" class="lower-section">
              <div class="lower-card">
              <div class="lower-tab-bar">
                <button class="lower-tab-btn" :class="{active: lowerTab==='cargo'}"    @click="lowerTab='cargo'">Cargo</button>
                <button class="lower-tab-btn" :class="{active: lowerTab==='notes'}"    @click="lowerTab='notes'">Notes</button>
                <button class="lower-tab-btn" :class="{active: lowerTab==='manifest'}" @click="lowerTab='manifest'">Manifest</button>
                <button class="lower-tab-btn" :class="{active: lowerTab==='schedule'}" @click="lowerTab='schedule'">Schedule</button>
              </div>

              <div class="lower-tab-content">
                <!-- Cargo -->
                <div v-show="lowerTab==='cargo'">
                  <label class="lower-field-label">Goods Weight <span class="lower-unit">(tonnes)</span></label>
                  <input v-model.number="goodsWeight" type="number" min="0" step="0.1" class="lower-input" placeholder="e.g. 2.5" />
                  <p class="lower-hint" :class="{ 'lower-hint--required': awaitingWeight.length }">
                    <template v-if="awaitingWeight.length">
                      Required for {{ awaitingWeight.join(', ') }} — {{ awaitingWeight.length === 1 ? 'it is' : 'they are' }} priced by weight.
                    </template>
                    <template v-else>Leave blank if not applicable.</template>
                  </p>
                </div>

                <!-- Notes -->
                <div v-show="lowerTab==='notes'">
                  <label class="lower-field-label">Order Notes</label>
                  <textarea v-model="formNotes" class="lower-textarea" placeholder="Special instructions, handling requirements…" rows="2"></textarea>
                </div>

                <!-- Documents (manifest + anything else this client must supply) -->
                <div v-show="lowerTab==='manifest'">
                  <div v-for="entry in docEntries" :key="entry.key" class="req-doc-row">
                    <div class="req-doc-head">
                      <span class="req-doc-name">
                        {{ entry.doc_type }}
                        <span v-if="entry.scope === 'stop'" class="req-doc-scope">drop-off {{ entry.stop_index + 1 }}</span>
                      </span>
                      <span class="req-doc-badge" :class="{ 'req-doc-badge--ok': entrySatisfied(entry) }">
                        {{ entrySatisfied(entry) ? 'Ready' : 'Required' }}
                      </span>
                    </div>
                    <input
                      v-if="entry.require_number"
                      v-model="entry.doc_number"
                      class="lower-input"
                      :placeholder="entry.doc_type + ' number'"
                    />
                    <div v-if="entry.require_file" class="req-doc-file">
                      <label class="req-doc-file-btn">
                        <input type="file" class="req-doc-file-input" @change="uploadDocFile(entry, $event)" />
                        {{ entry.uploading ? 'Uploading…' : entry.file_name ? 'Replace file' : 'Attach file' }}
                      </label>
                      <span v-if="entry.file_name" class="req-doc-file-name">{{ entry.file_name }}</span>
                    </div>
                  </div>

                  <template v-if="showFreeManifest">
                    <label class="lower-field-label">Manifest Number</label>
                    <input v-model="formManifestNumber" class="lower-input" placeholder="e.g. MAN-2024-001" />
                  </template>

                  <p v-if="!docEntries.length && !showFreeManifest" class="req-doc-empty">
                    No documents are required for this order.
                  </p>
                </div>

                <!-- Schedule -->
                <div v-show="lowerTab==='schedule'">
                  <el-date-picker
                    v-model="formScheduledDate"
                    type="datetime"
                    placeholder="Pick a date & time"
                    :disabled-date="disableScheduleDate"
                    :default-time="new Date(2000,0,1,9,0,0)"
                    format="ddd D MMM YYYY  ·  HH:mm"
                    class="schedule-dt-picker"
                    style="width:100%"
                  />
                </div>
              </div>

              </div><!-- /lower-card -->

              <!-- Confirm button at the very bottom -->
              <button
                @click="placeOrder"
                :disabled="!formActiveVehicleType || orderRequestInProgress || order_loading || !documentsReady || documentsUploading"
                class="confirm-btn"
                :class="{'confirm-btn--active': formActiveVehicleType}"
              >
                <svg v-if="!order_loading" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                <span v-if="order_loading" class="confirm-spinner"></span>
                {{ order_loading ? 'Placing order…' : !formActiveVehicleType ? 'Select a vehicle above' : documentsUploading ? 'Uploading documents…' : !documentsReady ? 'Attach required documents' : `Confirm — ${formActiveVehicleType}` }}
              </button>
            </div>
          </div>
        </div>
        </Transition>
      </div>
    </div>
    </div><!-- /outer-new-request-panel -->


 <!-- Floating action buttons — bottom right -->
    <div class="track-fab-group">
     
      <button class="track-fab track-fab--purple" @click="router.push('/transactions/orders')">
  <svg 
    width="18" 
    height="18" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    stroke-width="2" 
    stroke-linecap="round" 
    stroke-linejoin="round" 
    style="margin-right: 8px; vertical-align: text-bottom;"
  >
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1Z" />
    <line x1="16" y1="8" x2="8" y2="8" />
    <line x1="16" y1="12" x2="8" y2="12" />
    <line x1="10" y1="16" x2="8" y2="16" />
  </svg>
  Order History
</button>
    </div>

    <GMapMap
      :center="mapCenter"
      :zoom="14"
      map-type-id="roadmap"
      :options="mapOptions"
      style="position:absolute; top:0; left:0; right:0; bottom:0; width:100%; height:100%;"
      ref="myMapRef"
    >
      <GMapMarker
        :key="index"
        v-for="(m, index) in formMarkers"
        :position="m.position"
        :clickable="false"
        :draggable="false"
        :icon="getMarkerIcon(index)"
      />
      <GMapPolyline
        v-if="routePath.length > 1"
        :path="routePath"
        :options="polylineOptions"
      />
    </GMapMap>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, reactive, watch, nextTick, onMounted } from "vue";
import router from "../../router";
import { MapLocation, Delete } from "@element-plus/icons-vue";
import { message } from '../../utils/message';
declare const google: any;
import { useAuthStore } from "../../store/authStore";
import api from "../../api";

const store = useAuthStore();

const defaultTime = new Date(2000, 1, 1, 12, 0, 0);

const tabsStretchSettings = ref(true);
const isValidForm = ref(false);
const loading = ref(false);
const order_loading = ref(false);
const showMinimisedBody = ref(true);

const maxDeliveryLocations = ref(5);
const formActiveVehicleType = ref("");
const formNotes = ref("");
const formManifestNumber = ref("");

/* ── Required order documents ──────────────────────────────────────────────
   Some clients cannot pay an invoice unless specific paperwork travelled with
   the order. Ops declare the rules per client in the TMS; we fetch them and
   force them here. The server enforces the same rules regardless, so this is
   guidance rather than the guard. */
type DocRule = { scope: "order" | "stop"; doc_type: string; require_file: boolean; require_number: boolean };
type DocEntry = DocRule & {
  key: string;
  stop_index: number;
  doc_number: string;
  token: string | null;
  file_name: string | null;
  uploading: boolean;
};

const docRules = ref<DocRule[]>([]);
const docEntries = ref<DocEntry[]>([]);

// NOTE: declared here but NOT evaluated here — formInputs is a `const` defined
// much further down this file, so reading it before that line hits the temporal
// dead zone. The watch that reads this lives next to formInputs for that reason.
const dropoffCount = computed(() => Math.max(0, formInputs.locations.length - 1));

/* One row per order-scope rule, and one per drop-off for stop-scope rules.
   Rebuilt when the rules or the number of drop-offs change, carrying over
   anything already filled in so adding a stop never wipes an upload. */
const rebuildDocEntries = () => {
  const previous = new Map(docEntries.value.map((e) => [e.key, e]));
  const next: DocEntry[] = [];
  for (const rule of docRules.value) {
    const slots = rule.scope === "stop" ? dropoffCount.value : 1;
    for (let i = 0; i < slots; i++) {
      const key = `${rule.scope}|${rule.doc_type}|${i}`;
      const kept = previous.get(key);
      next.push({
        ...rule,
        key,
        stop_index: i,
        doc_number: kept?.doc_number ?? "",
        token: kept?.token ?? null,
        file_name: kept?.file_name ?? null,
        uploading: false,
      });
    }
  }
  docEntries.value = next;
};
// The watch on [docRules, dropoffCount] is registered AFTER formInputs is
// declared — see below. watch() evaluates its sources immediately to capture
// their initial values, and dropoffCount reads formInputs, so registering it
// here threw "Cannot access 'formInputs' before initialization", killing setup()
// and rendering the whole page blank.

const entrySatisfied = (e: DocEntry) =>
  (!e.require_number || e.doc_number.trim() !== "") && (!e.require_file || !!e.token);

const documentsReady = computed(() => docEntries.value.every(entrySatisfied));
const documentsUploading = computed(() => docEntries.value.some((e) => e.uploading));

/* A Manifest number typed in the free field is only meaningful when no rule
   already asks for one — otherwise the rule's own row owns it. */
const showFreeManifest = computed(
  () => !docRules.value.some((r) => r.scope === "order" && r.doc_type.toLowerCase() === "manifest")
);

const uploadDocFile = async (entry: DocEntry, ev: Event) => {
  const input = ev.target as HTMLInputElement;
  const file = input.files?.[0];
  if (!file) return;
  entry.uploading = true;
  try {
    const fd = new FormData();
    fd.append("file", file);
    // The shared axios instance sends JSON by default, so override per call.
    const res = await api.post("customer/orders/documents", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    entry.token = res.data.data.token;
    entry.file_name = res.data.data.file_name || file.name;
  } catch (err: any) {
    entry.token = null;
    entry.file_name = null;
    input.value = "";
    message.error(err.response?.data?.message || "Could not upload that file");
  } finally {
    entry.uploading = false;
  }
};

/* The placement payload's documents block. Includes the free-text manifest
   number when it is in use, which is how that field finally reaches the TMS. */
const buildDocumentsPayload = () => {
  const docs = docEntries.value.map((e) => ({
    scope: e.scope,
    stop_index: e.stop_index,
    doc_type: e.doc_type,
    doc_number: e.doc_number.trim() || null,
    token: e.token,
  }));
  if (showFreeManifest.value && formManifestNumber.value.trim() !== "") {
    docs.push({
      scope: "order",
      stop_index: 0,
      doc_type: "Manifest",
      doc_number: formManifestNumber.value.trim(),
      token: null,
    });
  }
  return docs;
};
const formScheduledDate = ref("");
const lowerTab          = ref<'cargo' | 'notes' | 'manifest' | 'schedule'>('cargo');

const scheduleMin = computed(() => new Date().toISOString().slice(0, 16));
const scheduleMax = computed(() => {
  const d = new Date();
  d.setDate(d.getDate() + 7);
  return d.toISOString().slice(0, 16);
});
const myMapRef = ref<any>(null);
const routePath = ref<{ lat: number; lng: number }[]>([]);
const activeRequestActionHeaderName = ref("firstAction");
const orderRequestInProgress = ref(false);

// Config from API
const vehicleTypes = ref<string[]>([]);
const currency = ref("KES");

// Distance calculated from Google Directions (km)
const distanceKm   = ref(0);
// Pickup to destination with the drops in between removed — what a rate card prices on.
const directKm     = ref(0);
const distanceText = ref('');
const routePolyline = ref('');

// Pricing state
const pricingResult   = ref<any>(null);
const pricingError    = ref("");
const showPricePanel  = ref(false);
const goodsWeight     = ref<number | null>(null);
const pricingParams   = ref<any>(null); // snapshot of params used at quote time
const allPrices       = ref<{ vehicle_type: string; result: any; error: string }[]>([]);
let   priceDebounceTimer: ReturnType<typeof setTimeout> | null = null;
let   priceInFlight = false;
const vehicleTab      = ref<'small' | 'medium' | 'large'>('small');

// The exact string the API hands back for a rate card that prices by weight
// (riley-api CustomerOrdersController::priceBulk). It is a customer-safe label
// rather than the raw pricing message, which is why it is matched literally.
const WEIGHT_REQUIRED = 'Goods weight required';

// Vehicles that would price if a weight were given. Bidco's 10T, 14T and 28T
// are charged per kilogram, so with no weight they come back unpriced while the
// small trucks on the same card price fine — and the tab that opens is the one
// that worked, so without this the customer never learns why the big trucks are
// greyed out.
const awaitingWeight = computed(() =>
  allPrices.value.filter(i => !i.result && i.error === WEIGHT_REQUIRED).map(i => i.vehicle_type)
);

const vehicleGroups = computed(() => {
  const small: typeof allPrices.value   = [];
  const medium: typeof allPrices.value  = [];
  const large: typeof allPrices.value   = [];
  allPrices.value.forEach(item => {
    const n = item.vehicle_type.toLowerCase();
    if (n.includes('bike') || n.includes('motorbike') || n.includes('motorcycle')) small.push(item);
    else if (n.includes('pick') || n.includes('pickup') || n.includes('3t'))       medium.push(item);
    else                                                                            large.push(item);
  });
  return { small, medium, large };
});

interface googleLocation {
  name: string;
  lat: number;
  lng: number;
  place_id: string;
  key: number;
}

interface formStruct {
  locations: googleLocation[];
}

interface markerStruct {
  position: { lat: number; lng: number };
}
const formMarkers = reactive<markerStruct[]>([]);

const mapCenter = reactive<googleLocation>({
  name: "", key: 0, lat: -1.26723, lng: 36.81026, place_id: "",
});

const formInputs = reactive<formStruct>({
  locations: [
    { name: "", key: 0, lat: 0, lng: 0, place_id: "" },
    { name: "", key: 1, lat: 0, lng: 0, place_id: "" },
  ],
});

/* Rebuild the required-document rows when the rules load or the number of
   drop-offs changes. Registered here, immediately after formInputs, because
   watch() evaluates its sources straight away and dropoffCount reads
   formInputs — doing this earlier in the file put formInputs in its temporal
   dead zone, which threw during setup() and left the page blank. */
watch([docRules, dropoffCount], rebuildDocEntries, { deep: true });

const removeLocation = (index: number) => {
  formInputs.locations.splice(index, 1);
  removeMarker(index);
  occasionalFormValidityCheck();
  resetPricing();
};

const removeMarker = (index: number) => { formMarkers.splice(index, 1); };

const setPlace = async (details: any, index: number) => {
  try {
    let location = {
      lat: details.geometry.location.lat(),
      lng: details.geometry.location.lng(),
      key: Date.now(),
      name: `${details.name} ${details.formatted_address}`,
      place_id: details.place_id,
    };
    formInputs.locations.splice(index, 1, location);
    addMarker(location, index);
    await nextTick();
    occasionalFormValidityCheck();
    resetPricing();
  } catch {
    message.error("Failed to add the location, please retry");
  }
};

const addMarker = (location: any, index: number) => {
  let { lat, lng } = location;
  formMarkers.splice(index, 1, { position: { lat, lng } });
};

const fetchDirectionsRoute = async () => {
  if (formMarkers.length < 2) { routePath.value = []; distanceKm.value = 0; directKm.value = 0; return; }
  try {
    const directionsService = new google.maps.DirectionsService();
    const waypoints = formMarkers.slice(1, -1).map((m: any) => ({
      location: m.position, stopover: true,
    }));
    const result = await directionsService.route({
      origin: formMarkers[0].position,
      destination: formMarkers[formMarkers.length - 1].position,
      waypoints,
      travelMode: google.maps.TravelMode.DRIVING,
      optimizeWaypoints: true,
    });
    // Store total distance
    let totalMeters = 0;
    let distTexts: string[] = [];
    result.routes[0].legs.forEach((leg: any) => {
      totalMeters += leg.distance.value;
      distTexts.push(leg.distance.text);
    });
    distanceKm.value   = totalMeters / 1000;
    distanceText.value = distTexts.join(' + ');

    // The same trip with the intermediate drops taken out. Rate-card customers
    // price pickup-to-destination and ignore what happens in between, so a
    // three-drop order must not be banded as though it drove the whole circuit.
    // With no waypoints this is the number we already have; only multi-drop
    // costs a second lookup, and if that fails the full route stands, which
    // overestimates rather than undercharges.
    if (!waypoints.length) {
      directKm.value = distanceKm.value;
    } else {
      try {
        const direct = await directionsService.route({
          origin: formMarkers[0].position,
          destination: formMarkers[formMarkers.length - 1].position,
          travelMode: google.maps.TravelMode.DRIVING,
        });
        directKm.value = direct.routes[0].legs
          .reduce((m: number, l: any) => m + l.distance.value, 0) / 1000;
      } catch {
        directKm.value = distanceKm.value;
      }
    }
    routePolyline.value = result.routes[0].overview_polyline ?? '';

    const path: { lat: number; lng: number }[] = [];
    result.routes[0].legs.forEach((leg: any) => {
      leg.steps.forEach((step: any) => {
        step.path.forEach((pt: any) => { path.push({ lat: pt.lat(), lng: pt.lng() }); });
      });
    });
    routePath.value = path;
  } catch {
    routePath.value  = formMarkers.map((m: any) => m.position);
    distanceKm.value = 0;
    directKm.value   = 0;
    distanceText.value  = '';
    routePolyline.value = '';
  }
};

const updateBounds = () => {
  fetchDirectionsRoute();
  const mapInstance = myMapRef.value;
  try {
    if (mapInstance) {
      mapInstance.$mapPromise.then((map: any) => {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < formMarkers.length; i++) { bounds.extend(formMarkers[i].position); }
        map.fitBounds(bounds, { left: 440, top: 40, right: 40, bottom: 40 });
      });
    }
  } catch (e) { console.warn('fitBounds skipped:', e); }
};

const addNewDestination = () => {
  formInputs.locations.push({ name: "", key: Date.now(), lat: 0, lng: 0, place_id: "" });
  occasionalFormValidityCheck();
};

const disableScheduleDate = (date: Date) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const max = new Date(now);
  max.setDate(max.getDate() + 7);
  return date < now || date > max;
};

const occasionalFormValidityCheck = () => {
  const emptyLocations = formInputs.locations.filter(l => l.name === "");
  isValidForm.value = emptyLocations.length === 0;
  if (!isValidForm.value) showMinimisedBody.value = true;
  updateBounds();
};

const handleRequestActionTab = (_tab: any, _event: Event) => {};

const autocompleteOptions: any = {
  componentRestrictions: { country: "ke" },
  fields: ["geometry", "name", "place_id", "formatted_address", "address_components", "types"],
};

const isNewLocationPickupIcon = (index: number) => index == 0;
const isNewLocationDeliveryIcon = (index: number) => index != 0;
const setPlaceHolderName = (index: number) => index == 0 ? "Pick-up address" : "Drop-off address";
const displayDeleteIcon = (index: number) => index >= 2;
const allowNewLocation = computed(() => formInputs.locations.length < maxDeliveryLocations.value && isValidForm.value);

const resetPricing = () => {
  showMinimisedBody.value     = true;
  showPricePanel.value        = false;
  pricingResult.value         = null;
  pricingError.value          = "";
  allPrices.value             = [];
  formActiveVehicleType.value = "";
  pricingParams.value         = null;
};

const selectVehicle = (item: { vehicle_type: string; result: any; error: string }) => {
  if (!item.result) return;
  formActiveVehicleType.value = item.vehicle_type;
  pricingResult.value         = item.result;
};

const getPriceQuote = () => {
  if (priceDebounceTimer) clearTimeout(priceDebounceTimer);
  priceDebounceTimer = setTimeout(_executePriceQuote, 500);
};

// Weight is an input to the price, so changing it has to re-price. Without
// this the customer is stuck: both Get Price buttons are hidden once the panel
// is open, so a weight typed after the first quote changed nothing at all and
// there was no way to ask again short of re-entering the addresses.
watch(goodsWeight, () => {
  if (!showPricePanel.value) return;
  getPriceQuote();
});

const _executePriceQuote = async () => {
  if (priceInFlight) return;
  if (distanceKm.value <= 0) {
    message.warning("Could not calculate route distance. Please check your locations."); return;
  }
  if (!vehicleTypes.value.length) {
    message.warning("No vehicle types configured."); return;
  }

  priceInFlight = true;
  loading.value = true;
  pricingError.value = "";
  allPrices.value = [];
  // Remembered across the re-quote a weight change triggers: having your
  // selection cleared because you typed a number is its own small bug.
  const wasSelected = formActiveVehicleType.value;
  formActiveVehicleType.value = "";
  pricingResult.value = null;
  showPricePanel.value = false;

  const pickup = formInputs.locations[0];
  const dest   = formInputs.locations[formInputs.locations.length - 1];
  const basePayload = {
    distance_km:  distanceKm.value,
    direct_km:    directKm.value,
    num_stops:    formInputs.locations.length - 1,
    goods_weight: goodsWeight.value ?? 0,
    pickup_lat:   pickup.lat,
    pickup_lng:   pickup.lng,
    dest_lat:     dest.lat,
    dest_lng:     dest.lng,
  };
  pricingParams.value = { ...basePayload }; // freeze snapshot for order submission

  try {
    const res = await api.post("customer/orders/price/bulk", {
      vehicle_types: vehicleTypes.value,
      ...basePayload,
    });
    allPrices.value = (res.data.data?.prices ?? []) as { vehicle_type: string; result: any; error: string }[];
    const g = vehicleGroups.value;
    vehicleTab.value = g.small.some(i => i.result) ? 'small' : g.medium.some(i => i.result) ? 'medium' : 'large';
    showPricePanel.value    = true;
    showMinimisedBody.value = false;

    const again = allPrices.value.find(i => i.vehicle_type === wasSelected && i.result);
    if (again) {
      formActiveVehicleType.value = again.vehicle_type;
      pricingResult.value         = again.result;
      // Stay on the tab holding the vehicle they had picked.
      for (const [key, group] of Object.entries(vehicleGroups.value)) {
        if (group.some(i => i.vehicle_type === wasSelected)) {
          vehicleTab.value = key as 'small' | 'medium' | 'large';
        }
      }
    }
  } catch (err: any) {
    pricingError.value = err.response?.data?.message || 'Could not load prices. Please try again.';
    message.error(pricingError.value);
  } finally {
    loading.value = false;
    priceInFlight = false;
  }
};

const placeOrder = async () => {
  if (!pricingResult.value) { message.warning("Please get a price first"); return; }
  if (!documentsReady.value) {
    message.warning("Please attach the required documents before placing this order");
    lowerTab.value = "manifest";
    return;
  }
  if (orderRequestInProgress.value) return;
  orderRequestInProgress.value = true;
  order_loading.value = true;

  const idempotencyKey = crypto.randomUUID();

  const pickup = formInputs.locations[0];
  const dest   = formInputs.locations[formInputs.locations.length - 1];

  const stops = formInputs.locations.map((loc, i) => ({
    address:       loc.name,
    lat:           loc.lat,
    lng:           loc.lng,
    type:          i === 0 ? "pickup" : "delivery",
    contact_name:  "",
    contact_phone: "",
    notes:         i === 0 ? formNotes.value : "",
  }));

  try {
    const res = await api.post("customer/orders", {
      pickup:           pickup.name,
      destination:      dest.name,
      vehicle_type:     formActiveVehicleType.value,
      stops,
      distance_km:      pricingParams.value.distance_km,
      direct_km:        pricingParams.value.direct_km,
      distance_text:    distanceText.value,
      polyline:         routePolyline.value,
      num_stops:        pricingParams.value.num_stops,
      goods_weight:     pricingParams.value.goods_weight,
      pickup_lat:       pricingParams.value.pickup_lat,
      pickup_lng:       pricingParams.value.pickup_lng,
      dest_lat:         pricingParams.value.dest_lat,
      dest_lng:         pricingParams.value.dest_lng,
      delivery_date:    formScheduledDate.value ? new Date(formScheduledDate.value).toISOString().split("T")[0] : null,
      customer_amount:  pricingResult.value.customer_amount,
      pricing_model:    pricingResult.value.pricing_model,
      pricing_snapshot: pricingResult.value.breakdown,
      documents:        buildDocumentsPayload(),
    }, { headers: { 'X-Idempotency-Key': idempotencyKey } });
    const data = res.data.data;
    message.success(`Order ${data.order_ref} placed!`);
    router.push(`/track/${data.order_id}`);
  } catch (err: any) {
    message.error(err.response?.data?.message || "Failed to place order");
  } finally {
    order_loading.value = false;
    orderRequestInProgress.value = false;
  }
};

const mapOptions = {
  styles: [
    { elementType: "geometry", stylers: [{ color: "#eaf0fb" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#3d4a5c" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
    { featureType: "administrative", elementType: "geometry", stylers: [{ visibility: "off" }] },
    { featureType: "administrative.land_parcel", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#c8e6c9" }] },
    { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#388e3c" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#dce6f5" }] },
    { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#b8cef5" }] },
    { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#9ab8e8" }] },
    { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#0061eb" }] },
    { featureType: "road.local", stylers: [{ visibility: "simplified" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#a8cce0" }] },
    { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d6b8a" }] },
  ],
  disableDefaultUI: true,
  zoomControl: false,
};

const MARKER_COLORS = ['#22c55e', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];
const polylineOptions = {
  strokeColor: "#2563eb", strokeOpacity: 1.0, strokeWeight: 5, geodesic: true,
};

const getMarkerIcon = (index: number) => {
  const color = MARKER_COLORS[index % MARKER_COLORS.length];
  const label = String.fromCharCode(65 + index);
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="44" viewBox="0 0 36 44">
      <filter id="shadow${index}" x="-30%" y="-30%" width="160%" height="160%">
        <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.25)"/>
      </filter>
      <ellipse cx="18" cy="42" rx="6" ry="2.5" fill="rgba(0,0,0,0.12)"/>
      <path d="M18 2C10.268 2 4 8.268 4 16c0 10 14 26 14 26s14-16 14-26C32 8.268 25.732 2 18 2z" fill="${color}" filter="url(#shadow${index})"/>
      <circle cx="18" cy="16" r="8" fill="white" opacity="0.92"/>
      <text x="18" y="20" text-anchor="middle" font-size="9" font-weight="700" font-family="DM Sans, sans-serif" fill="${color}">${label}</text>
    </svg>`;
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: { width: 36, height: 44 },
    anchor: { x: 18, y: 44 },
  };
};

onMounted(async () => {
  try {
    const res = await api.get("/config");
    vehicleTypes.value = res.data.data.vehicle_types || [];
    currency.value     = res.data.data.currency || "KES";
    // Max drop-offs is TMS-configured per surface; +1 for the pickup location.
    const maxDropoffs  = Number(res.data.data.customer_web_app_max_stops) || 4;
    maxDeliveryLocations.value = maxDropoffs + 1;
  } catch {
    // silently fail — user can still use the form
  }

  // Per-client document rules. Authenticated and customer-scoped, unlike
  // /config which is public and global.
  try {
    const res = await api.get("customer/order-config");
    docRules.value = res.data.data.required_documents || [];
    rebuildDocEntries();
  } catch {
    // No rules reachable — the server still enforces, so placement will explain.
  }
});
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&display=swap');

.ep-main, .el-main {
  padding: 0 !important;
  position: relative;
  height: 100%;
  width: 100%;
  flex: 1;
  font-family: 'DM Sans', sans-serif;
}

/* ── Outer container ──────────────────────── */
.outer-new-request-panel {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  /*max-width: 1280px; */
  margin: 0 auto;
  padding: 0 30px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;
  z-index: 10;
}

/* ── Panel ────────────────────────────────── */
.new-request-panel {
  position: absolute;
  top: 24px;
  width: 420px;
  max-height: calc(100vh - 110px);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 38px rgba(15,23,42,0.12), 0 2px 8px rgba(15,23,42,0.06);
  z-index: 10;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  pointer-events: all;
  transition: max-height 0.35s cubic-bezier(0.4,0,0.2,1);
}
.new-request-panel::-webkit-scrollbar { display: none; }
.new-request-panel-content { padding: 0; }

/* ── Panel header section (locations) ────── */
.new-request-head {
  background: #ffffff;
  padding: 24px 4px 16px;
  border-radius: 16px 16px 0 0;
}

/* ── Panel body ───────────────────────────── */
.new-request-body-section {
  padding: 12px 9px 14px;
  background: #ffffff;
}

/* ── Panel expand/collapse transition ─────── */
.panel-slide-enter-active, .panel-slide-leave-active {
  transition: all 0.32s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}
.panel-slide-enter-from, .panel-slide-leave-to {
  opacity: 0; max-height: 0; transform: translateY(-6px);
}
.panel-slide-enter-to, .panel-slide-leave-from {
  opacity: 1; max-height: 600px; transform: translateY(0);
}

/* ── Location inputs ──────────────────────── */
.request-stop {
  width: 100%;
  height: 42px;
  border-radius: 10px;
  border: 1.5px solid #e3e8ef;
  background: #f7f9fc;
  color: #1f2a37;
  padding: 0 12px;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.86rem;
  outline: none;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  box-sizing: border-box;
}
.request-stop::placeholder { color: #9aa4b2; }
.request-stop:focus {
  border-color: #0061eb;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(0,97,235,0.10);
  outline: none;
}

.new-request-location-icon {
  height: -webkit-fill-available;
  color: #9aa4b2;
}

.new-request-location-icon__actionable {
  cursor: pointer;
  color: #9aa4b2;
  background: #f0f2f5;
  border-radius: 50%;
  width: 26px; height: 26px;
  display: flex; align-items: center; justify-content: center;
  margin: auto;
  transition: background 0.15s, color 0.15s;
  margin-top: 7px;
}
.new-request-location-icon__actionable:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.12);
}

.new-request-location-row-breather { margin: 6px 0; }
.new-request-location-row-breather__minimal { margin: 4px; }

.new-request-add-destination-button { float: left; cursor: pointer; }
.add-destination {
  color: #0061eb;
  font-weight: 600; font-size: 0.8rem;
  text-decoration: none;
  display: flex; align-items: center; gap: 6px;
  padding: 4px 0;
  transition: color 0.15s;
}
.add-destination:hover { color: #003a96; }
.new-request-pickup-location-icon { color: #16a34a; }
.new-request-delivery-location-icon { color: #ef4444; }

/* ── Divider ──────────────────────────────── */
:deep(.ep-divider), :deep(.el-divider) {
  margin: 0 !important;
  border-color: #eef2f7 !important;
}

/* ── Get Price button ─────────────────────── */
.get-price-row {
  padding: 0 9px;
}
.get-price-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: #0061eb;
  color: white;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
  letter-spacing: 0.01em;
}
.get-price-btn:hover:not(:disabled) { opacity: 0.9; }
.get-price-btn:disabled { opacity: 0.55; cursor: not-allowed; }

/* ── Tabs ─────────────────────────────────── */
:deep(.ep-tabs__header), :deep(.el-tabs__header) { margin-bottom: 10px !important; }
:deep(.ep-tabs__item), :deep(.el-tabs__item) {
  font-family: 'DM Sans', sans-serif !important;
  font-size: 0.82rem !important; font-weight: 500 !important;
  color: #9ca3af !important; padding: 0 12px !important;
}
:deep(.ep-tabs__item.is-active), :deep(.el-tabs__item.is-active) { color: #0061eb !important; }
:deep(.ep-tabs__active-bar), :deep(.el-tabs__active-bar) { background-color: #0061eb !important; }
:deep(.ep-tabs__nav-wrap::after), :deep(.el-tabs__nav-wrap::after) {
  background-color: #e5e7eb !important; height: 1px !important;
}

/* ── Vendor rows ──────────────────────────── */
.new-request-vendors-panel { margin-bottom: 4px; }
.request-vendor-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 14px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer; margin-bottom: 6px;
  transition: border-color 0.15s, background 0.1s, box-shadow 0.15s;
  background: white;
}
.request-vendor-row:hover {
  border-color: #0061eb; background: #f0f6ff;
  box-shadow: 0 2px 8px rgba(0,97,235,0.08);
}
.request-vendor-row__active {
  border-color: #0061eb !important;
  background: linear-gradient(135deg, #e8f0ff 0%, #dbeafe 100%) !important;
  box-shadow: 0 2px 10px rgba(0,97,235,0.12) !important;
}
.request-vendor-row :deep(.ep-row), .request-vendor-row :deep(.el-row) { width: 100%; align-items: center; }
.request-vendor-row div { height: auto !important; }
.request-vendor-row-icon { display: flex; align-items: center; color: #6b7280; }
.request-vendor-row-label { font-size: 0.84rem; font-weight: 500; color: #374151; text-align: center; }
.request-vendor-row-label p { margin: 0; padding: 0; }
.request-vendor-row-amount { font-size: 0.84rem; font-weight: 700; color: #0061eb; text-align: right; }
.request-vendor-row-amount p { margin: 0; padding: 0; }

/* ── Required order documents ─────────────── */
.req-doc-row { border:1px solid #e6e9f0; border-radius:10px; padding:9px 10px; margin-bottom:8px; }
.req-doc-head { display:flex; align-items:center; justify-content:space-between; margin-bottom:6px; gap:8px; }
.req-doc-name { font-size:12px; font-weight:600; color:#1f2937; }
.req-doc-scope { font-size:10.5px; font-weight:500; color:#8a94a6; margin-left:5px; }
.req-doc-badge { font-size:9.5px; font-weight:700; text-transform:uppercase; letter-spacing:.05em;
  padding:2px 7px; border-radius:999px; background:#fef3c7; color:#92400e; white-space:nowrap; }
.req-doc-badge--ok { background:#dcfce7; color:#166534; }
.req-doc-file { display:flex; align-items:center; gap:8px; margin-top:6px; }
.req-doc-file-btn { display:inline-block; cursor:pointer; font-size:11.5px; font-weight:600; color:#1a56db;
  background:#eff6ff; border:1px solid #dbeafe; border-radius:8px; padding:5px 10px; white-space:nowrap; }
.req-doc-file-input { display:none; }
.req-doc-file-name { font-size:11px; color:#6b7280; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.req-doc-empty { font-size:11.5px; color:#8a94a6; margin:2px 0 0; }

/* ── Notes / Manifest / Schedule ─────────── */
.cargo-size-heading {
  font-size: 0.68rem; color: #9ca3af; margin: 0;
  text-transform: uppercase; letter-spacing: 0.05em;
}
.request-form-notes { width: 100%; }
:deep(.request-form-notes .ep-textarea__inner),
:deep(.request-form-notes .el-textarea__inner) {
  border-radius: 10px !important; border: 1.5px solid #e5e7eb !important;
  font-family: 'DM Sans', sans-serif !important; font-size: 0.84rem !important;
  color: #374151 !important; background: white !important;
  padding: 10px 12px !important; resize: none; box-shadow: none !important;
  transition: border-color 0.15s !important;
}
:deep(.request-form-notes .ep-textarea__inner:focus),
:deep(.request-form-notes .el-textarea__inner:focus) { border-color: #0061eb !important; }
:deep(.request-form-notes .ep-input__wrapper),
:deep(.request-form-notes .el-input__wrapper) {
  border-radius: 10px !important; border: 1.5px solid #e5e7eb !important;
  background: white !important; box-shadow: none !important;
  padding: 0 12px !important; height: 42px !important;
}
:deep(.request-form-notes .ep-input__wrapper:focus-within),
:deep(.request-form-notes .el-input__wrapper:focus-within) {
  border-color: #0061eb !important; box-shadow: none !important;
}
:deep(.request-form-notes .ep-input__inner),
:deep(.request-form-notes .el-input__inner) {
  font-family: 'DM Sans', sans-serif !important; font-size: 0.84rem !important; color: #374151 !important;
}

.request-form-schedule-label {
  display: block; font-size: 0.75rem; font-weight: 600; color: #6b7280;
  text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 8px;
}
.request-form-schedule-date { width: 100%; }
:deep(.request-form-schedule-date .ep-input__wrapper),
:deep(.request-form-schedule-date .el-input__wrapper),
:deep(.request-form-schedule-date .ep-input__wrapper:focus-within),
:deep(.request-form-schedule-date .el-input__wrapper:focus-within),
:deep(.request-form-schedule-date .ep-input__wrapper.is-focus),
:deep(.request-form-schedule-date .el-input__wrapper.is-focus) {
  border-radius: 10px !important;
  border: 1.5px solid #e5e7eb !important;
  background: white !important;
  box-shadow: none !important;
  outline: none !important;
  height: 42px !important;
  font-family: 'DM Sans', sans-serif !important;
}
:deep(.request-form-schedule-date .ep-input__prefix-inner),
:deep(.request-form-schedule-date .el-input__prefix-inner) { color: #9ca3af !important; }
:deep(.request-form-schedule-date .ep-input__inner),
:deep(.request-form-schedule-date .el-input__inner) {
  font-family: 'DM Sans', sans-serif !important;
  font-size: 0.84rem !important;
  color: #374151 !important;
}

/* ── Lower pill tab section ───────────────── */
.lower-section {
  padding: 0 9px 8px;
  margin-top: 6px;
}

.lower-card {
  background: white;
  border: 1.5px solid #b8d0f8;
  border-radius: 12px;
  padding: 5px 5px 14px;
  overflow: visible;
}

.lower-tab-bar {
  display: flex;
  gap: 3px;
  background: #e8f2ff;
  border-radius: 8px;
  padding: 3px;
  margin-bottom: 10px;
}

.lower-tab-btn {
  flex: 1;
  height: 26px;
  border: none;
  border-radius: 6px;
  background: transparent;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.74rem;
  font-weight: 600;
  color: #6b8abf;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.lower-tab-btn.active {
  background: white;
  color: #0061eb;
  box-shadow: 0 1px 4px rgba(0,97,235,0.1);
}
.lower-tab-btn:hover:not(.active) { color: #475569; }

.lower-tab-content {
  background: transparent;
  padding: 0 7px;
}

.lower-field-label {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 5px;
}
.lower-unit { font-weight: 500; text-transform: none; letter-spacing: 0; color: #94a3b8; }
.lower-hint--required { color: #b45309; font-weight: 600; }

.weight-prompt {
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  flex-wrap: wrap;
  background: #fffbeb; border: 1px solid #fde68a; border-radius: 10px;
  padding: 10px 12px; margin-bottom: 10px;
}
.weight-prompt-text { font-size: 12px; color: #92400e; line-height: 1.45; flex: 1 1 200px; }
.weight-prompt-text strong { font-weight: 700; }
.weight-prompt-field { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }
.weight-prompt-input {
  width: 84px; padding: 6px 9px; border: 1.5px solid #fcd34d; border-radius: 8px;
  font-size: 13px; font-weight: 600; color: #1e293b; background: #fff; outline: none;
  text-align: right;
}
.weight-prompt-input:focus { border-color: #0061eb; }
.weight-prompt-unit { font-size: 11.5px; font-weight: 600; color: #92400e; }

.lower-input {
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border: 1.5px solid #b8d0f8;
  border-radius: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.82rem;
  color: #1e293b;
  background: #f0f6ff;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.lower-input:focus { border-color: #6b8abf; background: white; }
.lower-input::placeholder { color: #94a3b8; }

.lower-textarea {
  width: 100%;
  padding: 7px 10px;
  border: 1.5px solid #b8d0f8;
  border-radius: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.82rem;
  color: #1e293b;
  background: #f0f6ff;
  outline: none;
  box-sizing: border-box;
  resize: none;
  transition: border-color 0.15s;
  line-height: 1.45;
}
.lower-textarea:focus { border-color: #6b8abf; background: white; }
.lower-textarea::placeholder { color: #94a3b8; }

.lower-hint {
  font-size: 0.68rem;
  color: #94a3b8;
  margin: 4px 0 0;
}

/* Schedule el-date-picker */
:deep(.schedule-dt-picker .ep-input__wrapper),
:deep(.schedule-dt-picker .el-input__wrapper) {
  border-radius: 8px !important;
  border: 1.5px solid #b8d0f8 !important;
  background: #f0f6ff !important;
  box-shadow: none !important;
  height: 36px !important;
  padding: 0 10px !important;
}
:deep(.schedule-dt-picker .ep-input__wrapper:focus-within),
:deep(.schedule-dt-picker .el-input__wrapper:focus-within) {
  border-color: #6b8abf !important;
  background: white !important;
  box-shadow: none !important;
}
:deep(.schedule-dt-picker .ep-input__inner),
:deep(.schedule-dt-picker .el-input__inner) {
  font-family: 'DM Sans', sans-serif !important;
  font-size: 0.82rem !important;
  color: #1e293b !important;
}
:deep(.schedule-dt-picker .ep-input__prefix-inner),
:deep(.schedule-dt-picker .el-input__prefix-inner) {
  color: #94a3b8 !important;
}


/* ── Confirm button (bottom) ──────────────── */
.confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  height: 40px;
  margin-top: 10px;
  border: none;
  border-radius: 11px;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: not-allowed;
  transition: opacity 0.15s, background 0.2s;
  background: #ccdeff;
  color: #94a3b8;
}
.confirm-btn--active {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(22,163,74,0.3);
}
.confirm-btn--active:hover { opacity: 0.92; }
.confirm-btn:disabled { opacity: 0.65; }
.confirm-spinner {
  width: 14px; height: 14px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  display: inline-block;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ── Floating action buttons ──────────────── */
.track-fab-group {
  position: absolute;
  bottom: 100px;
  right: 32px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 10;
  pointer-events: all;
}
.track-fab {
  height: 44px;
  padding: 0 22px;
  border-radius: 22px;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.84rem;
  font-weight: 700;
  cursor: pointer;
  border: none;
  transition: all 0.18s cubic-bezier(0.4,0,0.2,1);
  letter-spacing: 0.02em;
  white-space: nowrap;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15), 0 1.5px 4px rgba(0,0,0,0.08);
  width:200px;
}
.track-fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.2), 0 2px 6px rgba(0,0,0,0.1);
}
.track-fab:active { transform: translateY(0); }
.track-fab--green {
  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
  color: white;
}
.track-fab--purple {
  background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%);
  color: white;
}
</style>